import { FC, ReactNode } from 'react';
import { Route, Routes } from 'react-router-dom';
import { WalletView } from './views/WalletView';
// import { WalletData } from './WalletData';

export interface WalletProps {
    placeholder?: ReactNode;
}

export const Wallet: FC<WalletProps> = ({ placeholder }) => {
    return (
        <Routes>
            <Route
                path="*"
                element={
                    // <WalletData>
                    <WalletView placeholder={placeholder} />
                    // </WalletData>
                }
            />
        </Routes>
    );
};
